<template>
  <div>
    <label v-if="label" :for="name">{{ label }}</label>
    <textarea
      :maxlength="maxlength"
      :id="name"
      v-model="_value"
      :class="[{ 'is-invalid': invalid }, height]"
      :placeholder="placeholder"
      class="min-height-100px w-100 text-secondary border border-secondary border-opacity-50 rounded-4 bg-pink p-3 mb-4 mt-2"
      @keyup="emit('keyup')"
      @keydown.enter="emit('onEnter')"
    ></textarea>
    <div class="invalid-feedback">
      {{ invalid }}
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseTextarea",
};
</script>

<script setup>
import { computed, defineProps, defineEmits } from "vue";

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  invalid: {
    type: String,
    default: "",
  },
  height: {
    type: String,
    default: "",
  },
  maxlength: {
    type: Number,
    default: 524288,
  },
});

const emit = defineEmits(["update:value", "keyup", "onEnter"]);
const _value = computed({
  get() {
    return props.value;
  },
  set(val) {
    emit("update:value", val);
  },
});
</script>

<style scoped>
.min-height-100px {
  min-height: 100px;
}
</style>
